import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments';
import { Observable } from 'rxjs';
import { ResponseApiDto } from '../DTOs/_response-api.dto';
import { TrashDocumentItemEntity } from '../entities/trash-document-item.entity';

@Injectable({
    providedIn: 'root',
})
export class TrashDocumentItemApi {
    private prefix = 'trash-document-item';

    //* Injects
    private _httpClient = inject(HttpClient);


    /**
     * Retorna uma lista de itens da lixeira de um documento
     * @param documentId ID of document
     * @returns Observable of ResponseApiDto<TrashDocumentItemEntity[]>
     */
    public getAllByDocumentId(documentId: string): Observable<ResponseApiDto<TrashDocumentItemEntity[]>> {
        const url = `${environment.API_BASE}${this.prefix}/get-all-by-document-id/${documentId}`;

        return this._httpClient.get<ResponseApiDto<TrashDocumentItemEntity[]>>(url);
    }

    /**
     * Restaura um item da lixeira de um documento
     * @param _id ID of item
     * @returns Observable of ResponseApiDto<void>
     */
    public restore(documentId: string, _ids: string[]): Observable<ResponseApiDto<void>> {
        const url = `${environment.API_BASE}${this.prefix}/restore-fields`;
        const body = {
            documentId,
            ids: _ids,
        };

        return this._httpClient.patch<ResponseApiDto<void>>(url, body);
    }

    /**
     * Restaura um item da lixeira de um documento
     * @param _id ID of item
     * @returns Observable of ResponseApiDto<void>
     */
    public deletePermanently(documentId: string, _ids: string[]): Observable<ResponseApiDto<void>> {
        const url = `${environment.API_BASE}${this.prefix}/delete-permanently`;
        const body = {
            documentId,
            ids: _ids,
        };

        return this._httpClient.patch<ResponseApiDto<void>>(url, body);
    }
}
